import React, {useEffect, useState} from 'react'
import '../../../../../../../styles/kp-11Generic-catalog-card.css'
import GenericKP11CardNumberInput from '../kp-11-generic-cards/kp11-generic-card-number-input'
import {normalizeQuantity} from '../../../../kp-11Link-utility/kp11-utility'

export const KP11AdditionalPageCard = ({
  name,
  price,
  isChecked,
  groupKey,
  itemCode,
  onSave,
  quantity,
  disabled,
}) => {
  const [value, setValue] = useState(String(normalizeQuantity(quantity)))
  const [isExpanded, setIsExpanded] = useState(isChecked)

  useEffect(() => {
    setValue(String(normalizeQuantity(quantity)))
  }, [quantity])

  useEffect(() => {
    setIsExpanded(isChecked)
  }, [isChecked])

  const handleChange = newValue => {
    setValue(newValue)
  }

  return (
    <GenericKP11CardNumberInput
      name={name || 'Additional Pages'}
      price={price}
      isDisabled={disabled}
      isChecked={isExpanded}
      onClick={() => setIsExpanded(true)}
      label="Quantity"
      value={value}
      onChange={handleChange}
      min={1}
      max={25}
      groupKey={groupKey}
      itemCode={itemCode}
      onSave={finalValue => onSave(finalValue)}
      existingquantity={Number(quantity) || 0}
      quantityValidationRequired={true}
    />
  )
}
